export default __webpack_public_path__ + "static/media/RakSatelliteLogo.ef62e616.JPG";